module.exports = __webpack_public_path__ + "img/icon_learninglength@2x.4120b643.png";